export default __webpack_public_path__ + "static/media/Diagnostics.90ccb14e.webp";